import { t } from 'i18next';
import { snakeCase } from 'lodash-es';
import { useCallback, useMemo } from 'react';

import useDispatchNumberFilterLabel from '~hooks/useDispatchNumberFilterLabel';

// Pages declare the dispatch numbers filter with different enum values ('dispatchNumbers',
// 'dispatch_numbers'), so it is matched on the snake-cased translation key they share.
const DISPATCH_NUMBERS_FILTER_KEY = 'dispatch_numbers';

export default function useFilterCategoryLabels() {
  const resolveFilterLabel = useDispatchNumberFilterLabel();

  const categoryLabel = useCallback(
    (filter: string) => {
      const filterKey = snakeCase(filter);

      return resolveFilterLabel(
        filterKey === DISPATCH_NUMBERS_FILTER_KEY,
        t(`dispatch.dispatch_v2.filters.${filterKey}`),
      );
    },
    [resolveFilterLabel],
  );

  return useMemo(
    () => ({
      categoryLabel,
      // React escapes at render; i18next's global escapeValue would turn the "/" in
      // "Customer Ref./PO" into "&#x2F;".
      allEntitiesLabel: (filter: string) =>
        t('dispatch.dispatch_v2.filters.all_entities', {
          entity: categoryLabel(filter),
          interpolation: { escapeValue: false },
        }),
      noEntitiesLabel: (filter: string) =>
        t('dispatch.dispatch_v2.filters.no_entities', {
          entity: categoryLabel(filter),
          interpolation: { escapeValue: false },
        }),
    }),
    [categoryLabel],
  );
}
